import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, SectionLabel } from "./Reveal";

const FAQ = {
  owners: [
    { q: "What kinds of properties do you work with?", a: "Apartment communities, HOAs, retail and shopping centers, offices, churches and any private lot with a parking problem." },
    { q: "Do I need signs before you can tow?", a: "Yes. Proper tow-away signage must be posted before enforcement begins. We'll walk you through it and help get it installed." },
    { q: "Can I request a single tow instead of patrols?", a: "Absolutely. Call dispatch and we'll come out for one-time removals as well as ongoing enforcement." },
    { q: "How do I stay updated on tows at my property?", a: "Our property manager app keeps you in the loop on enforcement activity, with a record of every removal from your property." },
    { q: "What is Pay 2 Park?", a: "Pay 2 Park lets drivers pay to park on your lot, bringing more revenue to your property while Warrior keeps your parking rules enforced. Ask us about it in the quote form or by phone." },
    { q: "How do I get started?", a: "Fill out the patrol quote form above or call 980-251-4838. We'll schedule a walk of your property and set up the rules you want enforced." },
  ],
  drivers: [
    { q: "How do I know if Warrior towed my car?", a: "Call us with your plate number, make and model and where it was parked. We'll confirm whether we have it." },
    { q: "What do I need to pick up my vehicle?", a: "A valid photo ID, proof of ownership (registration or title) and payment — we take cash, credit/debit cards (no American Express) and Zelle. Call ahead so we can have everything ready." },
    { q: "Where is the impound lot?", a: "2708 Midland Ave, Charlotte, NC 28208. Releases are Monday–Friday 10 AM–5 PM and Saturday–Sunday 10 AM–2 PM." },
    { q: "Can I pick up my car after hours?", a: "Yes — call dispatch to arrange it. After-hours pickups carry a $75 after-hours fee." },
    { q: "Can someone else pick up my car?", a: "Call us first — we'll explain what's required for someone other than the registered owner." },
  ],
};

const TABS = [{ id: "owners", label: "Property owners" }, { id: "drivers", label: "Vehicle owners" }];

export const Faq = () => {
  const [tab, setTab] = useState("owners");
  return (
    <section id="faq" data-testid="faq-section" className="border-t border-[var(--line)] bg-[var(--ink-2)]">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:py-36">
        <Reveal className="lg:col-span-4">
          <SectionLabel index="07">FAQ</SectionLabel>
          <h2 className="font-display text-5xl font-black uppercase leading-[0.9] sm:text-6xl">Straight<br />answers.</h2>
          <div className="mt-10 flex gap-2">
            {TABS.map((t) => (
              <button key={t.id} data-testid={`faq-tab-${t.id}`} onClick={() => setTab(t.id)}
                className={`px-4 py-2.5 font-mono text-xs uppercase tracking-[0.15em] transition-colors duration-300 ${tab === t.id ? "bg-[var(--signal)] text-[var(--ink)]" : "border border-[var(--line)] text-zinc-300 hover:text-white"}`}>
                {t.label}
              </button>
            ))}
          </div>
        </Reveal>
        <Reveal className="lg:col-span-7 lg:col-start-6">
          <Accordion key={tab} type="single" collapsible defaultValue="item-0">
            {FAQ[tab].map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-[var(--line)]">
                <AccordionTrigger data-testid={`faq-q-${tab}-${i}`} className="py-6 text-left font-display text-2xl font-extrabold uppercase leading-tight hover:no-underline sm:text-3xl">{f.q}</AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-zinc-300">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
